import { apiUrl, logOut, password } from "./auth";

// Calls the stats API with the password typed in at login. The password is never
// built into the site, so it can't be read from the page's code.
const fetchData = async (endpoint, body = {}) => {
  const response = await fetch(apiUrl(endpoint), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${password.value}`,
    },
    body: JSON.stringify(body),
  });
  if (response.status === 401) {
    logOut();
  }
  if (!response.ok) {
    throw new Error(`${endpoint} failed with ${response.status}`);
  }
  return response.json();
};

export default fetchData;
